import { render, staticRenderFns } from "./detail.dialog.vue?vue&type=template&id=d382f520&scoped=true"
import script from "./detail.dialog.vue?vue&type=script&lang=js"
export * from "./detail.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d382f520",
  null
  
)

export default component.exports